import axios from 'axios'

export const toolsBase64Image = (data) => {
  return axios.post('/tools/base64Image', data)
}
